/* 19.9.2026 ilta: varausajastin (10 min) + alennuskoodit korissa.
   ERILLINEN TIEDOSTO opt-cart.js:n rinnalla, jotta ostoskorin ydin pysyy koskemattomana.
   Ladataan snippets/opt-cart-body.liquidin lopusta (script defer). Snippet renderoituu
   /cart-sivulla kahdesti (sivu + laatikko), joten alla on suoja tuplakaynnistysta vastaan.
   Laatikon uudelleenrenderointi (innerHTML) EI suorita script-tageja, joten yksi instanssi.

   Ajastin: 10 min (data-cart-secs) siita kun korissa on ensimmaisen kerran jotain,
   sessionStoragessa. Nakyy vain kun Liquid renderoi [data-cart-timer]-elementin
   (kori ei tyhja). Nollassa teksti vaihtuu, kori sailyy. Kun laatikko renderoituu
   uudelleen (lisays/muutos) ja aika on umpeutunut, ajastin alkaa alusta.

   Koodit: /cart/update.js { discount: "KOODI" } (Cart AJAX API, 5/2025) KORVAA koko
   koodilistan. Omistaja 19.9. ilta: koodit EIVAT yhdisty (stacking pois), joten uusi koodi
   KORVAA edellisen. Jos uusi koodi ei kelpaa (applicable:false), edellinen lista palautetaan
   ja nayteaan viesti. Laatikko paivitetaan OptCart.refresh():lla, /cart-sivulla reload. */
(function () {
  if (window.OptCartExtras) return;
  var KEY = 'optCartResv';
  function els() { return document.querySelectorAll('[data-cart-timer]'); }
  function get() { try { return parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (e) { return 0; } }
  function set(t) { try { sessionStorage.setItem(KEY, String(t)); } catch (e) {} }
  function secs() { var f = els()[0]; return (f && parseInt(f.dataset.cartSecs, 10)) || 600; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var list = els();
    if (!list.length) return;
    var now = Date.now(), end = get();
    list.forEach(function (t) {
      if (!t.dataset.init) {
        t.dataset.init = '1';
        /* tuore elementti (sivun lataus tai laatikon uudelleenrenderointi):
           kaynnista jos ajastinta ei ole tai se on umpeutunut */
        if (!end || end < now) { end = now + secs() * 1000; set(end); }
      }
    });
    var left = Math.max(0, Math.round((end - now) / 1000));
    list.forEach(function (t) {
      var v = t.querySelector('[data-cart-timer-val]');
      if (v) v.textContent = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
      t.classList.toggle('is-over', left === 0);
      var s = t.querySelector('span');
      if (s && left === 0 && !t.dataset.over) { t.dataset.over = '1'; s.textContent = 'Varausaika päättyi. Tuotteet ovat yhä korissasi.'; }
    });
  }
  setInterval(tick, 1000);
  function watch() {
    var scroll = document.getElementById('OptCartScroll');
    if (scroll && window.MutationObserver) new MutationObserver(tick).observe(scroll, { childList: true });
    tick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();

  function json(r) { return r.json(); }
  function codes() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(json)
      .then(function (c) { return (c.discount_codes || []).map(function (d) { return d.code; }); })
      .catch(function () { return []; });
  }
  function update(list) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: list.join(',') })
    }).then(json);
  }
  function refresh() { return window.OptCart && window.OptCart.refresh ? window.OptCart.refresh() : Promise.resolve(); }
  function onCartPage() { return !!document.querySelector('.opt-cartpage'); }
  function applyDiscount(code) {
    code = (code || '').trim().toUpperCase();
    if (!code) return Promise.resolve({ ok: false });
    return codes().then(function (prev) {
      return update([code]).then(function (d) {
        var hit = ((d && d.discount_codes) || []).filter(function (x) { return (x.code || '').toUpperCase() === code; })[0];
        var ok = !!(hit && hit.applicable);
        if (ok) return refresh().then(function () { return { ok: true, cart: d }; });
        /* ei kelvannut: palauta edellinen koodi, jotta se ei katoa */
        return update(prev).then(refresh).then(function () { return { ok: false, cart: d }; });
      });
    }).catch(function () { return { ok: false }; });
  }
  function removeDiscount(code) {
    code = (code || '').toUpperCase();
    return codes().then(function (list) { return update(list.filter(function (c) { return c.toUpperCase() !== code; })); })
      .then(refresh);
  }
  function msg(form, text, ok) {
    var m = form && form.parentNode ? form.parentNode.querySelector('[data-cart-discount-msg]') : null;
    if (!m) return;
    m.textContent = text || '';
    m.hidden = !text;
    m.classList.toggle('ok', !!ok);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-cart-discount]') : null;
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[name=discount]');
    var code = input ? (input.value || '').trim().toUpperCase() : '';
    if (!code) return;
    form.classList.add('is-busy');
    msg(form, '');
    applyDiscount(code).then(function (res) {
      if (res.ok && onCartPage()) { window.location.reload(); return; }
      var f2 = document.querySelector('[data-cart-discount]') || form;
      f2.classList.remove('is-busy');
      if (res.ok) { msg(f2, 'Koodi ' + code + ' lisätty.', true); }
      else {
        msg(f2, 'Koodi ' + code + ' ei kelpaa tähän koriin.');
        var i2 = f2.querySelector('input');
        if (i2) i2.value = code;
      }
    });
  });
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-cart-discount-remove]') : null;
    if (!b) return;
    e.preventDefault();
    removeDiscount(b.dataset.cartDiscountRemove).then(function () { if (onCartPage()) window.location.reload(); });
  });
  window.OptCartExtras = { applyDiscount: applyDiscount, removeDiscount: removeDiscount };
  if (window.OptCart) window.OptCart.applyDiscount = applyDiscount;
})();
